var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('el-menu',{attrs:{"default-active":_vm.$router.currentRoute.path,"mode":"horizontal","router":true}},[_c('el-menu-item',{attrs:{"index":"/"}},[_vm._v("Interview Copilot")]),_c('el-menu-item',{attrs:{"index":"/setting"}},[_vm._v("Setting")])],1),_c('router-view',{staticClass:"router_view"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }